import React, { useEffect, useState } from 'react';

import Select from "react-select";
import countries from './../../../Translate/countries.jsx';

const CountryList = ({saveCountry, countryOnLoad, multilingua, language}) => {
  const [searchTerm, setSearchTerm] = useState({});
  const countrier = Object.entries(countries[language] || {}).map(([key, value]) => ({
    value: value,
    label: value,
    key: key
  })); 

  const saveIso = (opt) => {
    saveCountry(opt?.key);
    setSearchTerm(opt);
  }
  useEffect(() => {
    if(countries[language] && countries[language][countryOnLoad]){
      const val = countries[language][countryOnLoad];
      setSearchTerm({value: val, label: val, key: countryOnLoad});
    }else{
      setSearchTerm({value: "Cameroon", label: "Cameroon", key: "cm"});
    }
  }, [countryOnLoad, language])  
  
  return (
    <div className="user-country columnize" >
       
      <label htmlFor="c">{multilingua}</label>
      <Select
        id="c"
        options={countrier}
        value={searchTerm}
        onChange={saveIso}
        placeholder="country"
        styles={{
          menu: (base) => ({
            ...base,
            maxHeight: "150px", 
            overflowY: "auto",  
          }),
          control: (base) => ({
            ...base,
            minHeight: "40px", 
          }),
          option: (base, { isSelected }) => ({
            ...base,
            padding: "8px 12px",
            backgroundColor: isSelected ? "#4CAF50" : "white",
            color: isSelected ? "white" : "black",
            ":hover": {
              backgroundColor: "#e0e0e0",
            },
          }),
        }}
        maxMenuHeight={150}
      />
    </div>
  );
};

export default CountryList;






